import React from "react";
import { Field } from "formik";
import {
  Modal,
  Form,
  Button,
  Collapse,
  Row,
  Col,
  InputGroup,
} from "react-bootstrap";
import { useWhitelabel } from "../../../../contexts/WhitelabelContext";

const AddWatchdogForm = ({
  values,
  errors,
  touched,
  setFieldValue,
  setFieldTouched,
  handleChange,
  handleBlur,
  handleSubmit,
  setValues,
  initialValues,
  handleClose,
  clearSelectedSims,
}) => {
  const { backgroundColor, fontColor } = useWhitelabel();

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        <Form.Label>Action Type</Form.Label>
        <Form.Select
          name="actionType"
          value={values.actionType}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={touched.actionType && errors.actionType}
        >
          <option value="">Select Action Type</option>
          <option value="NONE">None</option>
          <option value="SUSPEND">Suspend</option>
        </Form.Select>
        {!!touched.actionType && (
          <Form.Control.Feedback type="invalid">
            {errors.actionType}
          </Form.Control.Feedback>
        )}
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Watchdog Interval</Form.Label>
        <Form.Select
          name="watchdogInterval"
          value={values.watchdogInterval}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={Boolean(
            touched.watchdogInterval && errors.watchdogInterval
          )}
        >
          <option value="">Select period</option>
          <option value="daily">Daily</option>
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Amount</Form.Label>
        <Field
          type="text"
          name="amount"
          value={values.amount}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={touched.amount && errors.amount}
          className="form-control"
        />
        {!!touched.amount && (
          <Form.Control.Feedback type="invalid">
            {errors.amount}
          </Form.Control.Feedback>
        )}
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Service</Form.Label>
        <Form.Select
          name="service"
          value={values.service}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={Boolean(touched.service && errors.service)}
        >
          <option value="">Select Service</option>
          <option value="data">Data</option>
          <option value="sms">SMS</option>
        </Form.Select>
      </Form.Group>
      <Collapse in={values.actionType === "SUSPEND"} dimension="height">
        <div>
          <Form.Group className="mb-3">
            <Form.Check
              type="switch"
              label="Enable Suspend Interval?"
              checked={values.enableSuspendInterval}
              name="enableSuspendInterval"
              onChange={(e) =>
                setFieldValue("enableSuspendInterval", e.target.checked)
              }
              style={{
                "--dynamic-bg-color": backgroundColor,
                "--dynamic-font-color": fontColor,
              }}
              onBlur={handleBlur}
            />
          </Form.Group>
          <Collapse in={values.enableSuspendInterval} dimension="height">
            <Form.Group className="mb-3">
              <Form.Label>Suspend Interval</Form.Label>
              <Form.Select
                name="suspendInterval"
                value={values.suspendInterval}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={Boolean(
                  touched.suspendInterval && errors.suspendInterval
                )}
              >
                <option value="">Select period</option>
                <option value="daily">Daily</option>
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
              </Form.Select>
            </Form.Group>
          </Collapse>
        </div>
      </Collapse>

      <Form.Group className="mb-3">
        <Form.Label>Unit Type</Form.Label>
        <Form.Select
          name="unitType"
          value={values.unitType}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={Boolean(touched.unitType && errors.unitType)}
        >
          {!values.service.includes("sms") && (
            <>
              <option value="Bytes">Byte</option>
              <option value="KB">Kilobyte</option>
              <option value="MB">Megabyte</option>
            </>
          )}
          {values.service.includes("sms") && <option value="unit">Unit</option>}
        </Form.Select>
        {!!touched.unitType && (
          <Form.Control.Feedback type="invalid">
            {errors.unitType}
          </Form.Control.Feedback>
        )}
      </Form.Group>
      <Row className="mb-3">
        <Form.Group as={Col}>
          <Form.Label>Warning</Form.Label>
          <Form.Control
            type="text"
            name="warning"
            value={values.warning}
            onChange={handleChange}
            onBlur={handleBlur}
            isInvalid={touched.warning && errors.warning}
          />
          {!!touched.warning && (
            <Form.Control.Feedback type="invalid">
              {errors.warning}
            </Form.Control.Feedback>
          )}
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label>Warning 1</Form.Label>
          <Form.Control
            type="text"
            name="warning1"
            value={values.warning1}
            onChange={handleChange}
            onBlur={handleBlur}
            isInvalid={touched.warning1 && errors.warning1}
          />
          {!!touched.warning1 && (
            <Form.Control.Feedback type="invalid">
              {errors.warning1}
            </Form.Control.Feedback>
          )}
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label>Warning 2</Form.Label>
          <Form.Control
            type="text"
            name="warning2"
            value={values.warning2}
            onChange={handleChange}
            onBlur={handleBlur}
            isInvalid={touched.warning2 && errors.warning2}
          />
          {!!touched.warning2 && (
            <Form.Control.Feedback type="invalid">
              {errors.warning2}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Row>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={() => {
            setValues(initialValues);
            clearSelectedSims();
            handleClose();
          }}
          style={{
            "--dynamic-bg-color": backgroundColor,
            "--dynamic-font-color": fontColor,
            border: "none",
          }}
        >
          Cancel
        </Button>

        <Button
          variant="primary"
          type="submit"
          style={{
            "--dynamic-bg-color": backgroundColor,
            "--dynamic-font-color": fontColor,
            border: "none",
          }}
        >
          Submit
        </Button>
      </Modal.Footer>
    </Form>
  );
};

export default AddWatchdogForm;
